import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import EmployeeImportDataResultFile from "../model/EmployeeImportDataResultFile";

const DownloadEmployeeDataFileApiService = async (
  request: number
): Promise<EmployeeImportDataResultFile> => {
  const uri = `/employeeimportfiles/${request}/downloadImportFile/`;
  const { data } = await axios.post(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDownloadEmployeeDataFileApiService = () =>
  useMutation<EmployeeImportDataResultFile, AxiosError, number>(
    "DownloadEmployeeDataFileApiService",
    DownloadEmployeeDataFileApiService
  );

export default useDownloadEmployeeDataFileApiService;
